import { Link, useLocation } from "react-router";
import { Boxes, Camera, CircleUserRound, MessageSquare } from "lucide-react";
import { cn } from "@/lib/utils";
import { useUnreadCount } from "@/features/notifications/hooks";

const tabs = [
  { href: "/assistant", label: "Assistant", icon: MessageSquare },
  { href: "/catalog", label: "Catalog", icon: Boxes },
  { href: "/ingest", label: "Scan", icon: Camera },
  { href: "/you", label: "You", icon: CircleUserRound },
];

export function MobileTabBar() {
  const { pathname } = useLocation();
  const { data: unreadCount = 0 } = useUnreadCount();

  return (
    <nav className="bg-background relative z-30 shrink-0 border-t-2 pb-[env(safe-area-inset-bottom)] lg:hidden">
      <div className="flex items-center justify-around">
        {tabs.map((tab) => {
          const active = pathname.startsWith(tab.href);
          const showDot = tab.href === "/you" && unreadCount > 0;
          return (
            <Link
              key={tab.href}
              to={tab.href}
              aria-current={active ? "page" : undefined}
              aria-label={tab.label}
              className={cn(
                "flex flex-1 items-center justify-center py-2 transition-colors duration-200",
                active ? "text-primary" : "text-muted-foreground",
              )}
            >
              <span
                className={cn(
                  "relative flex items-center justify-center rounded-full p-2 transition-colors duration-200",
                  active && "bg-primary/15",
                )}
              >
                <tab.icon className="h-5 w-5" />
                {showDot && (
                  <span className="absolute top-0.5 right-0.5 h-2.5 w-2.5 rounded-full bg-red-500" />
                )}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
